import { request } from '@lib/request';

export function updateUserFunderMapping() {
    return request({
        method: 'post',
        url: '/api/migration/cognito-mapping-hook'
    })
}